module.exports = __webpack_public_path__ + "media/images/email-07c0dd6dea47c68a16cb1d8980b510cb.svg";